module.exports = __webpack_public_path__ + "dingbeauty-landing/img/icon_07.438fbde1.svg";